import {
    FACETED_SEARCH_QUERY,
    FACETED_SEARCH_RECEIVE,
    FACETED_SEARCH_TOGGLE_VALUE,
    FACETED_SEARCH_TOGGLE_COMPACT,
} from '../constants';
const defaultState = {
    subNavigation: null,
    sortCriteria: null,
    facetFilters: [],
    visibleDropdownMenu: [],
    navigationTheme: 'filter',
    productsViewCachedId: null,
    // true once a filter change has pushed a history entry on this page
    hasFilteredHistory: false,
};

export const facetedSearch = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FACETED_SEARCH_QUERY:
            return {
                ...state,
                hasFilteredHistory: true,
            };
        case FACETED_SEARCH_RECEIVE: {
            // A response that lacks filters, sort criteria or sub navigation
            // (e.g. a request made with an incomplete request context) must not
            // wipe out data that is already shown. Keep the existing values.
            const { facetFilters, sortCriteria, subNavigation, ...rest } =
                payload;
            return {
                ...state,
                ...rest,
                facetFilters:
                    facetFilters && facetFilters.length
                        ? facetFilters
                        : state.facetFilters,
                sortCriteria:
                    sortCriteria && sortCriteria.sortItems
                        ? sortCriteria
                        : state.sortCriteria,
                subNavigation: subNavigation || state.subNavigation,
            };
        }
        case FACETED_SEARCH_TOGGLE_VALUE:
            return {
                ...state,
                facetFilters: payload.facetFilters,
            };
        case FACETED_SEARCH_TOGGLE_COMPACT: {
            const { visibleDropdownMenu } = payload;
            return {
                ...state,
                visibleDropdownMenu: state.visibleDropdownMenu.includes(
                    visibleDropdownMenu
                )
                    ? []
                    : [visibleDropdownMenu],
            };
        }
        default:
            return state;
    }
};
